// extracted by mini-css-extract-plugin
module.exports =  {"summaryBanner":"summaryBanner__JJi3s"};